<template>
  <li
    @click="onSelected(item)"
    class="list_ul_li"
    :class="getUlLiClass"
    :style="{boxShadow:(selectedCount[item.id]? 'inset 0px 0px 1px 1px red':'')}"
  >
    <span v-if="isDantuoImg" class="g_dantuo_img"></span>
    <span class="number" :class="filterNumberColor(item.class3)">{{item.class3}}</span>
    <div v-if="renderShengxiaoData(item)" class="list_ul_li_shengxiao">
          <span v-for="(item, index) in renderShengxiaoData(item)"
                :key="'numberRow' + index"
                class="number"
                :class="filterNumberColor(item)"
          >
            {{item}}
          </span>
    </div>
    <span>{{`${item.odds1 ? `${item.odds}/${item.odds1}` : item.odds}`}}</span>
  </li>
</template>
<script>

  import { filterNumber, lhCurrentTabLength, lianMaWeishu_value } from "../../../../../utils/lhMethods";
  import objectPath from 'object-path';
  import { mapActions, mapState } from "vuex";

  export default {
    name: "tab-swiper-list-item",
    props: {
      item: {
        type: Object,
      },
      subId: Number,
      selectedId: Number,
      shengxiaoData: Array,
      selectedCount: Object,
      nextLottery: {
        type: Object,
        default: null
      },
    },

    data() {
      return {
        isDantuoImg: false,
      };
    },
    methods: {
      ...mapActions("root", ["setSelectedDantuoData"]),
      // 校验号码背景图片
      filterNumberColor(number) {
        const isFilterNumber = filterNumber(number);
        if (isFilterNumber) {
          return isFilterNumber;
        }
        return 'number_shengxiao';
      },
      onNumberRowFindItem(class3, numberGroup) {
        if (numberGroup) {
          return numberGroup.split(',');
        }
        const findItem = this.shengxiaoData.find(shengxiaoItem => shengxiaoItem.sx === class3);
        if (findItem) {
          if(this.item.class2=="六肖"&&(findItem.m_number=="01,13,25,37,49"||findItem.m_number=="01,13,25,37")){
            let newN = "01,13,25,37";
            return newN.split(',');
          }else if(findItem.m_number=="01,13,25,37"){
            let newN = "01,13,25,37,49";
            return newN.split(',');
          }else{
            return findItem.m_number.split(',');
          }
        }
        return '0';
      },
      // 涉及有胆拖的玩法
      isDantuoType() {
        if (this.subId === 6 || this.subId === 7 || this.subId === 8 || this.subId === 9 || this.subId === 11 || this.subId === 12 || this.subId === 13) {
          return true;
        }
        return false;
      },
      // 判断是否是胆拖
      tiggerDantuo(selectedDantuoData) {
        const {class3} = this.item;
        let DEFUALT_DANTUO_IMG = false;
        // 当有胆拖的玩法，并且类型为胆拖
        if (this.isDantuoType() && this.selectedShengxiaoPlayRadio == 2) {
          if (Object.keys(selectedDantuoData).some(dantuo => dantuo == class3)) {
            DEFUALT_DANTUO_IMG = true;
          }
        }
        this.isDantuoImg = DEFUALT_DANTUO_IMG;
      },
      // 所有的点击逻辑在父级处理，这里触发，只验证是否有胆拖
      onSelected(item) {
        const block_time = objectPath.get(this.nextLottery, 'block_time');
        if (!block_time || (block_time && isNaN(block_time) || block_time <= 0)) return;
        const isActive = this.selectedCount[item.id];
        // 触发子组件时间，判断是否是胆拖
        const firstOddItemClass2 = objectPath.get(item, 'class2');
        let newSelectedDantuoData = this.selectedDantuoData;
        let length = lhCurrentTabLength(firstOddItemClass2);
        let newLength = Object.keys(this.selectedDantuoData).length;

        if (!isActive) {
          // 把胆拖存起来
          if (newLength < length - 1) {
            newSelectedDantuoData = {
              ...newSelectedDantuoData,
              [item.class3]: item
            };
          }
        }
        if (isActive) {
          objectPath.del(newSelectedDantuoData, item.class3);
        }
        this.setSelectedDantuoData(newSelectedDantuoData);
        this.tiggerDantuo(newSelectedDantuoData);
        this.$emit("onSelected", item);
      }
    },
    computed: {
      ...mapState({
        selectedDantuoData: state => state.root.selectedDantuoData,
        selectedShengxiaoPlayRadio: state => state.root.selectedShengxiaoPlayRadio
      }),
      // 根据参数返回list item class
      getUlLiClass() {
        const block_time = objectPath.get(this.nextLottery, 'block_time');
        if (!block_time || (block_time && isNaN(block_time) || block_time <= 0)) {
          return 'ul_li_disabled';
        }
        return '';
      },
      renderShengxiaoData() {
        // 生肖跟尾数都是通过这个方法返回的，isTM用来区分特码同时展示了生肖 与尾数
        return (item, isTM = false) => {
          const {class2, class3, numberGroup} = item;
          // 半波
          if (this.subId === 14) {
            const DEFAULT_VALUE = {
              '红大': '29,30,34,35,40,45,46',
              '红小': '01,02,07,08,12,13,18,19,23,24',
              '红单': '01,07,13,19,23,29,35,45',
              '红双': '02,08,12,18,24,30,34,40,46',
              '蓝大': '25,26,31,36,37,41,42,47,48',
              '蓝小': '03,04,09,10,14,15,20',
              '蓝单': '03,09,15,25,31,37,41,47',
              '蓝双': '04,10,14,20,26,36,42,48',
              '绿大': '27,28,32,33,38,39,43,44',
              '绿小': '05,06,11,16,17,21,22',
              '绿单': '05,11,17,21,27,33,39,43',
              '绿双': '06,16,22,28,32,38,44',
            };
            return DEFAULT_VALUE[class3] && DEFAULT_VALUE[class3].split(',');
          }
          // 五行
          if (this.subId === 15) {
            const DEFAULT_VALUE = {
              '金': '01,06,11,16,21,26,31,36,41,46',
              '木': '02,07,12,17,22,27,32,37,42,47',
              '水': '03,08,13,18,23,28,33,38,43,48',
              '火': '04,09,14,19,24,29,34,39,44,49',
              '土': '05,10,15,20,25,30,35,40,45',
            };
            return DEFAULT_VALUE[class3] && DEFAULT_VALUE[class3].split(',');
          }
          // 特肖
          if (this.subId === 4) {
            if (this.shengxiaoData && class2 === '特肖') {
              return this.onNumberRowFindItem(class3, numberGroup);
            }
          }
          // 一肖尾数
          if (this.subId === 5) {
            if (this.shengxiaoData && (class2 === '一肖中' || class2 === '一肖不中')) {
              return this.onNumberRowFindItem(class3, numberGroup);
            }
          }
          // 合肖
          if (this.subId === 11 || this.subId === 6) {
            return this.onNumberRowFindItem(class3, numberGroup);
          }
          if (
            (this.subId === 8 && !isTM && (this.selectedShengxiaoPlayRadio === 3 || this.selectedShengxiaoPlayRadio === 5) && (this.selectedId === 3 || this.selectedId === 4 || this.selectedId === 5 || this.selectedId === 6))
          ) {
            return this.onNumberRowFindItem(class3, numberGroup);
          }
          // 连尾
          if (this.subId === 7 ||
            (this.subId === 8 && (this.selectedShengxiaoPlayRadio === 4 || this.selectedShengxiaoPlayRadio === 5) && (this.selectedId === 3 || this.selectedId === 4 || this.selectedId === 5 || this.selectedId === 6))
          ) {
            return lianMaWeishu_value[class3] && lianMaWeishu_value[class3].split(',');
          }
          return false;
        }
      },
    }
  };
</script>
<style lang="less" scoped>
  .list_ul_li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    background-color: #fff;
    padding: 0 2px;
    width: 20%;
    height: 76px;

    font-size: 3vw;
    box-sizing: border-box;
    font-weight: bold;
    border: 0.5px solid #EEE;

    .list_ul_li_state {
      width: 28%;
    }
  }

  .number {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    background-size: contain;
  }

  .number-blue {
    color:#0b0c0c;
    background: url('../../../../../../static/images/lh/back_blue.png') no-repeat center center;
  }

  .number-green {
    color:#0b0c0c;
    background: url('../../../../../../static/images/lh/back_green.png') no-repeat center center;
  }

  .number-red {
    color:#0b0c0c;
    background: url('../../../../../../static/images/lh/back_red.png') no-repeat center center;
  }

  .number_shengxiao {
    padding: 0 10px;
    border-radius: 4px;
    color: #fff;
    background-color: #FFAE13;
  }

  .list_ul_li_shengxiao {
    display: flex;
    max-width: 550px;
  }

  // 胆拖图片
  .g_dantuo_img {
    width: 52px;
    height: 57px;
    position: absolute;
    right: 20px;
    bottom: -14px;
    background: url('../../../../../../static/images/LM_D.gif') no-repeat center center;
    background-position-x: 98%;

  }

  .ul_li_disabled {
    background: #dddddd;
    cursor: not-allowed
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/hall/components/tab-swiper-lh/list-item.vue